import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
	page: {
		flexDirection: "row",
		backgroundColor: "#E4E4E4",
	},
	section: {
		padding: 20,
		flexGrow: 1,
	},
	chatBubble: {
		marginBottom: 10,
		padding: 10, // Adjust padding here
		backgroundColor: "#FFFFFF",
		borderRadius: 8,
		width: "75%",
		fontSize: 10, // Decrease font size here
	},
	senderAI: {
		alignSelf: "flex-start",
		backgroundColor: "#ebeded",
	},
	senderUser: {
		alignSelf: "flex-end",
		backgroundColor: "#3aadf0",
	},
});

const ChatPdf = ({ chats }) => {
	return (
		<Document>
			<Page size="A4" style={styles.page}>
				<View style={styles.section}>
					{chats.map((chat, index) => (
						<View
							key={index}
							style={[
								styles.chatBubble,
								chat.sender === "ai"
									? styles.senderAI
									: styles.senderUser,
							]}>
							<Text>{chat.desc}</Text>
						</View>
					))}
				</View>
			</Page>
		</Document>
	);
};

export default ChatPdf;
